import { SelectInputOption } from '../stories/SelectInput';

const ct = require('countries-and-timezones');

export const getBrowserTimezone = (): string | null => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
};

export const getRecommendedTimezoneOption = (timezoneOptions?: {
  [key: string]: string;
}): SelectInputOption | null => {
  const browserTimezone = getBrowserTimezone();
  const recommendedTimezoneOption =
    (!!browserTimezone &&
      !!timezoneOptions &&
      timezoneOptions[browserTimezone] && {
        label: timezoneOptions[browserTimezone],
        value: browserTimezone,
      }) ||
    null;

  if (!recommendedTimezoneOption) {
    // when the user's browser recommended timezone is not present in our timezone options array
    return getTimezoneOptionFromCtz(browserTimezone);
  }
  return recommendedTimezoneOption;
};

export const getTimezoneOptionFromCtz = (
  browserTimezone?: string | null,
): SelectInputOption | null => {
  const ctz = ct.getTimezone(browserTimezone);
  if (!browserTimezone) {
    // no timezone provided
    return null;
  }
  if (!ctz) {
    // timezone provided but not found
    return { label: browserTimezone, value: browserTimezone };
  }
  return {
    // timezone provided and found
    label: `(GMT${ctz.utcOffsetStr}) ${ctz.name}`,
    value: ctz.name,
  };
};
